import { render, staticRenderFns } from "./SecutityValidation.vue?vue&type=template&id=52a12b0d&scoped=true&"
import script from "./SecutityValidation.vue?vue&type=script&lang=js&"
export * from "./SecutityValidation.vue?vue&type=script&lang=js&"
import style0 from "./SecutityValidation.vue?vue&type=style&index=0&id=52a12b0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a12b0d",
  null
  
)

export default component.exports